import React from 'react';
import MultipleInput from './MultipleInput/MultipleInput';


const MultiControl = ({elem, header, footer, form, typ}) => {
    let input_type = {
        multiIntControl: "int",
        multiTextControl: "text",
        multiDecimalControl: "decimal",
        multiDropdown: "dropdown",
    }
    console.log(elem)
    return (
        <>
            {
                header ? (
                    <div className='multi-control-header'>
                        {
                            header.map((x, index) => (
                                <p key={index} style={x.style}>{x.text}</p>
                            ))
                        }
                    </div>
                ) : null
            }
            <MultipleInput
                sourceParams={elem.sourceParams || {}}
                dropDownData={elem.data}
                pname={elem.pname ? elem.pname : elem._id + "lbl"}
                searchable={elem.searchable || false}
                includeAll={elem.includeAll || false}
                form={form}
                inputType={input_type[typ]}
                name={elem._id}
                multiSelect={elem.multiSelect || false}
                labelColSpan={24}
                label={elem.label}
                numberOfFields={elem.inputBoxQty}
                disabled={elem.readOnly ? true : false}
                required={elem.required || elem.req}
                defaultValue={elem.defaultValue}
                errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
                minRequired={elem.minRequired ? elem.minRequired : null}
            />
            {
                footer ? (
                    <div className='multi-control-footer'>
                        {
                            footer.map((x, index) => (
                                <p key={index} style={x.style}>{x.text}</p>
                            ))
                        }
                    </div>
                ) : null
            }
        </>
    )
};

export default MultiControl;